module.exports = __webpack_public_path__ + "img/analysis_menu.80580d55.svg";